import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const Banner = () => {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const initParticles = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js-public", {
          particles: {
            number: { value: 220, density: { enable: true, value_area: 800 } },
            color: { value: "#ff0000" },
            shape: { type: "triangle" },
            opacity: { value: 0.5, random: true },
            size: { value: 3, random: true },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#ff0000",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 4,
              direction: "none",
              random: true,
              straight: false,
              out_mode: "out",
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: true, mode: "grab" },
              onclick: { enable: true, mode: "push" },
              resize: true,
            },
            modes: {
              grab: { distance: 140, line_linked: { opacity: 1 } },
              push: { particles_nb: 4 },
            },
          },
          retina_detect: true,
        });
      }
    };

    // Load particles.js script dynamically if not already loaded
    if (!document.getElementById("particles-script")) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/particles.js@2.0.0/particles.min.js";
      script.id = "particles-script";
      script.onload = initParticles;
      document.body.appendChild(script);
    } else {
      initParticles();
    }

    // // Cleanup on unmount
    // return () => {
    //   if (window.pJSDom && window.pJSDom.length) {
    //     // Find and destroy particles instance for public banner
    //     const pJSDomInstance = window.pJSDom.find(p => p.el.id === "particles-js-public");
    //     if (pJSDomInstance) {
    //       pJSDomInstance.pJS.fn.vendors.destroypJS();
    //       const cleanedPJSDom = window.pJSDom.filter(p => p.el.id !== "particles-js-public");
    //       window.pJSDom = cleanedPJSDom;
    //     }
    //     const canvas = document.querySelector("#particles-js-public canvas");
    //     if (canvas) canvas.remove();
    //   }
    // };
  }, []);

  return (
    <div className="h-full w-full relative flex items-center justify-center bg-black">

      {/* Particles Container */}
      <div id="particles-js-public" className="absolute inset-0 w-full h-full"></div>

      <div className="relative z-10 max-w-xl px-6 text-center text-white">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold">Osmosis Computer</h1>
        <p className="mt-4 text-lg sm:text-xl text-white/90">Quality learning resources for students and educators.</p>

        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to="/" className="bg-white text-black px-5 py-2 rounded-md font-semibold">Login</Link>
          <Link to="/registration/" className="border border-white text-white px-5 py-2 rounded-md font-semibold">Create account</Link>
        </div>

        <div className="mt-6 text-sm text-white/80">
          <span className="mr-4">Students: a growing library of courses</span>
          <span>•</span>
          <span className="ml-4">Instructors: easy course publishing</span>
        </div>
      </div>
    </div>
  );
};

export default Banner;
